module.exports = {
  entry: './src/apps/watsonx-code-assistant-price-estimator/index.tsx',
  shortcode: 'watsonx-code-assistant-price-estimator',
  title: 'watsonx Code Assistant Price Estimator',
  status: 'stable',
  description: 'Allows users to determine a price.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-watsonx-code-assistant-price-estimator-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
    org: 'digitalsales', // to filter the widget
    brand: 'dataai', // automation, dataai, security, storage, sustainability, other
    widgetLocation: '/pricing', // default '/pricing' but sometimes '/'
    productName: 'watsonx-code-assistant-ansible-lightspeed', // the product name in the URL
    activatedCountryPages: ['us-en'],
  },
};
